import { LOCATION_CHANGE } from '../../../../../shared/frontend/libs/router/redux-store';
import { GET_GUILD_ROSTER } from '../actions/getGuildRoster';
import { TAction } from '../actions/types/action';
import { TGuildRosterClientState } from '../libs/store';

export default function guildRoster(
  state: Partial<TGuildRosterClientState> = {},
  action: TAction<any>
): Partial<TGuildRosterClientState> {
  switch (action.type) {
    case GET_GUILD_ROSTER: {
      return {
        ...state,
        ...action.payload
      };
    }
    case LOCATION_CHANGE: {
      if (action.payload.isFirstRendering) {
        return state; // server render may have pre-populated state, so we don't want to nuke it
      }
      return {};
    }
    default: {
      return state;
    }
  }
}
